export default __webpack_public_path__ + "static/media/youtube.4a3751f8.svg";